import React from 'react';
import { useAtomValue } from 'jotai';
import Fade from '@smart-tv/components/fade/fade';
import ArrowBackIcon from '@smart-tv/components/icons/arrow-back-icon';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';
import { playerControlsOpenAtom } from './player-content/use-player-content';
import styles from './player-back-button.module.scss';
import { testIds } from '@smart-tv/e2e/shared/variables';
import { usePlayerContext } from './_contexts/player-context';
import useVodPlayer from './vod-wrapper/_hooks/use-vod-player';

interface Props {
  onClick: () => void;
}

export const PlayerBackButton: React.FC<Props> = ({ onClick }: Props) => {
  const controlsOpen = useAtomValue(playerControlsOpenAtom);
  const { firstTimeLoading } = usePlayerContext();
  const { isHandlingGetStream } = useVodPlayer();

  if (!IS_BROWSER || isHandlingGetStream) return null;

  return (
    <Fade in={controlsOpen || firstTimeLoading} unmountOnExit>
      <button
        className={styles['player-back-button']}
        onClick={onClick}
        data-testid={testIds.player.playerControls.back}
        aria-label="Luk afspiller"
      >
        <ArrowBackIcon size="xl" />
      </button>
    </Fade>
  );
};

export default React.memo(PlayerBackButton);
